// extracted by mini-css-extract-plugin
module.exports = {"page-name":"page-name-1fP0G","pageName":"page-name-1fP0G","page-name-input":"page-name-input-1Pxxa","pageNameInput":"page-name-input-1Pxxa"};